import Breadcrumb from 'components/Navigation/Breadcrumb';
import React from 'react';
import WillStatCard from './WillStatCard';
import { Link, useParams } from 'react-router-dom';
import Button from 'components/Form/Button';
import {
  useGetCustomerDetails,
  useGetCustomerInfoDetails
} from 'common/queries-and-mutations/admin/customer';
import { Loader } from 'components/Loader';
import UserAssets from './AssetsTypes';

export default function CustomerWillInfo() {
  const { customerId } = useParams();

  const { data, isLoading, isFetching } = useGetCustomerInfoDetails({
    customerId: +customerId!
  });

  const { data: user } = useGetCustomerDetails({
    customerId: +customerId!
  });

  if (isLoading && isFetching) {
    return (
      <div className="mt-40 flex flex-col items-center justify-center">
        <Loader color={'#FF6606'} height={50} width={50} />
      </div>
    );
  }

  return (
    <div className="mb-16 pb-16">
      <Breadcrumb title={`Customer - ${user?.othername} ${user?.surname}`} />
      <div className="my-5 grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-4">
        <div className="col-span-12 flex space-x-5 overflow-x-auto px-[var(--margin-x)] transition-all duration-[.25s] scrollbar-hide">
          <WillStatCard
            bgColor="#7A7C87"
            iconColor="#878995"
            type="Spouse"
            typeCount={data?.totalSpouse}
          />
          <WillStatCard
            bgColor="#f48aa5"
            iconColor="#FF4E75"
            type="Children"
            typeCount={data?.totalChildren}
          />
          <WillStatCard
            bgColor="#ff7900"
            iconColor="#FF6606"
            type="Beneficiary"
            typeCount={data?.totalBeneficiary}
          />
          <WillStatCard
            bgColor="#47307f"
            iconColor="#675499"
            type="Guardian"
            typeCount={data?.totalGuardian}
          />
          <WillStatCard
            bgColor="#00b388"
            iconColor="#4CB99F"
            type="Executor"
            typeCount={data?.totalExecutor}
          />
        </div>
      </div>
      <div className="flex items-center justify-between">
        <p className="text-2xl font-bold text-[#353535]">
          Customer Information
        </p>
        <div className="mt-5 flex items-center gap-x-5">
          <Link to={`/admin/customers/will-summary/${customerId}`}>
            <Button
              variant="primary"
              size="custom"
              className="h-5 rounded bg-[#585858] p-2.5 font-normal"
              label="Check Will Summary"
              type="button"
            ></Button>
          </Link>
        </div>
      </div>
      <div className="mt-2 flex flex-col space-y-3 overflow-y-auto px-[var(--margin-x)] transition-all duration-[.25s] scrollbar-hide md:h-[800px]">
        <UserAssets assets={data} user={user} />
      </div>
    </div>
  );
}
